module.exports = __webpack_public_path__ + "392ef036c895f7492b30457a1f5ef443.svg";